import { render, staticRenderFns } from "./TablePlanItems.vue?vue&type=template&id=4ed314f0&"
import script from "./TablePlanItems.vue?vue&type=script&lang=js&"
export * from "./TablePlanItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports